const CATEGORY_COVERS: Record<string, string> = {
  biztositas: "/brand/services/biztositas.jpg",
  "it-es-eszkozbeszerzes": "/brand/services/it-es-eszkozbeszerzes.jpg",
  "jogi-tanacsadas": "/brand/services/jogi-tanacsadas.jpg",
  konyveles: "/brand/services/konyveles.jpg",
  palyazatok: "/brand/services/palyazatok.jpg",
  praxismenedzsment: "/brand/services/praxismenedzsment.jpg",
};

const DEFAULT_SERVICE_COVER = "/brand/services/praxismenedzsment.jpg";

export function getServiceCoverFallback(categorySlug?: string | null) {
  if (categorySlug && CATEGORY_COVERS[categorySlug]) {
    return CATEGORY_COVERS[categorySlug];
  }

  return DEFAULT_SERVICE_COVER;
}

export function resolveServiceCoverUrl(
  coverUrl: string | null | undefined,
  categorySlug?: string | null,
) {
  return coverUrl || getServiceCoverFallback(categorySlug);
}
